import { UserImage } from "../UserImage";
import type { UserImageSizes } from "../UserImage/constants";

interface User {
  /** User name */
  name: string;
  /** User image URL */
  src: string;
}

export interface ThreeUserRowProps {
  /** Whether to use full rounded border-radius */
  isFullRounded?: boolean;
  /** Avatar size  */
  size?: UserImageSizes;
  /** Users array */
  users: User[];
}

/**
 * Displays an horizontal stack of up to three `UserImage` components. They
 * have their borders enabled by default with a `border-inherit` class, so you
 * can control the border color by wrapping the component with a div containing
 * a `border-*` class.
 */
export const ThreeUserRow = ({
  isFullRounded = false,
  size = "7",
  users,
}: ThreeUserRowProps) => {
  if (users.length === 0) {
    return null;
  }

  const [user1, user2, user3] = users;

  return (
    <div
      className="inline-flex flex-row-reverse border-inherit"
      data-testid="three-user-row"
    >
      {user3 && (
        <div
          className="-ml-1 inline-flex border-inherit"
          data-testid="user-row"
        >
          <UserImage
            hasBorder
            isFullRounded={isFullRounded}
            name={user3.name}
            size={size}
            src={user3.src}
          />
        </div>
      )}
      {user2 && (
        <div
          className="-ml-1 inline-flex border-inherit"
          data-testid="user-row"
        >
          <UserImage
            hasBorder
            isFullRounded={isFullRounded}
            name={user2.name}
            size={size}
            src={user2.src}
          />
        </div>
      )}
      {user1 && (
        <div className="inline-flex border-inherit" data-testid="user-row">
          <UserImage
            hasBorder
            isFullRounded={isFullRounded}
            name={user1.name}
            size={size}
            src={user1.src}
          />
        </div>
      )}
    </div>
  );
};

ThreeUserRow.displayName = "ThreeUserRow";
